module.exports = __webpack_public_path__ + "static/media/physician-avatar-bg.9b35da4d.png";